import { addGroup } from "../../../service/GroupService";
import { Form, Checkbox, Spin } from "antd";
import { useEffect, useState } from "react";
import InputWrapper from "../../../components/shared/Input/Input-Wrapper";

import CustomInput from "../../../components/global/CustomInput/CustomInput";
import CustomButton from "../../../components/global/Button/CustomButton";
import CustomModal from "../../../components/global/CustomModal/CustomModal";
import CustomLabelDropdown from "../../../components/shared/new Form/Fields/CustomLabelDropdown";
import { useActiveUsers } from "../../../hooks/GroupHooks/useGetActiveUser";
import {
  showErrorMessage,
  showSuccessMessage,
} from "../../../components/shared/pagination/messages";

const AddGroupModal = ({
  isModalOpen,
  getGroups,
  handleCloseModal,
  setLoading,
  loading,
}) => {
  const [form] = Form.useForm();
  const [searchValue] = useState("");

  const [selectedValues, setSelectedValues] = useState([]);

  const { userList, fetchActiveUsers } = useActiveUsers();

  const filteredUsers = userList?.filter((user) =>
    user.label.toLowerCase().includes(searchValue.toLowerCase()),
  );
  const allUserValues = filteredUsers?.map((user) => user.value) || [];
  const isAllSelected =
    selectedValues.length === allUserValues.length && allUserValues.length > 0;

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedValues(allUserValues);
      form.setFieldsValue({ employees: allUserValues });
    } else {
      setSelectedValues([]);
      form.setFieldsValue({ employees: [] });
    }
  };

  useEffect(() => {
    form.resetFields();
    fetchActiveUsers();
  }, []);

  const handleAdd = async () => {
    try {
      const values = await form.validateFields();

      setLoading(true);
      const result = await addGroup(values);

      if (result?.success) {
        showSuccessMessage("Group created successfully!");
        getGroups(1, 10);
        handleCloseModal();
      } else {
        showErrorMessage(result?.data || "Error occurred while adding group");
      }
    } catch (error) {
      if (error?.errorFields) return;
      showErrorMessage("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <CustomModal
      title={`Add New Group`}
      visible={isModalOpen}
      onCancel={handleCloseModal}
    >
      <Form
        form={form}
        layout="vertical"
        name="group_form"
        className="flex flex-col gap-[10px]"
      >
        <InputWrapper label="Group Name" required>
          <Form.Item
            name="groupName"
            rules={[{ required: true, message: "Group name is required!" }]}
          >
            <CustomInput autoComplete="off" placeholder="Enter group name" />
          </Form.Item>
        </InputWrapper>

        <InputWrapper label="Select Employees">
          <Form.Item name="employees">
            <CustomLabelDropdown
              placeholder="Select employees (Optional)"
              showSearch
              mode="multiple"
              optionFilterProp="label"
              filterOption={(input, option) => {
                const label = option?.label || option?.children || "";
                return label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
              }}
              maxTagCount="responsive"
              notFoundContent={
                loading ? <Spin size="small" /> : "No users available"
              }
              options={filteredUsers}
              dropdownRender={(menu) => (
                <>
                  <div className="px-3 py-2 border-b border-[#f0f0f0] cursor-pointer">
                    <Checkbox
                      checked={isAllSelected}
                      indeterminate={
                        selectedValues.length > 0 && !isAllSelected
                      }
                      onChange={(e) => handleSelectAll(e.target.checked)}
                    >
                      <strong>Select All</strong>
                    </Checkbox>
                  </div>
                  {menu}
                </>
              )}
            />
          </Form.Item>
        </InputWrapper>
      </Form>
      <div className="flex justify-center items-center gap-[10px] w-full pb-[12px] mt-4">
        <CustomButton className="!w-1/2" variant="primary" onClick={handleAdd}>
          Create
        </CustomButton>

        <CustomButton
          className="!w-1/2"
          variant="outlined"
          onClick={handleCloseModal}
        >
          Cancel
        </CustomButton>
      </div>
    </CustomModal>
  );
};
export default AddGroupModal;
